<div class="mx-2 my-6">
  <h1 class="p-4 text-3xl font-bold font-montserrat text-project-500">
    Access restricted
  </h1>
  <p class="p-4">
    You do not have permission to access requested page. Please contact an
    administrator to request access.
  </p>
</div>
